import React from 'react'
import styled from '@emotion/styled';
import constants, {color, breakpoint} from './../../constants';
import {wrapWithUtm, openRequestedPopup} from './../../helpers/link-helpers';
import pocketSvg from './pocket.svg';
import facebookSvg from './facebook.svg';
import twitterSvg from './twitter.svg';
import emailSvg from './email.svg';
import get from 'lodash/get';
import analyticsTriggers from '../../analytics/triggers';

const BodyGridColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: min-content;
  grid-gap: var(--body-lineheight);
  grid-row-gap: 0;
  
  ${breakpoint.atMediumWidth} {
    grid-template-columns: 20px 1fr 20px;
  }
`

// TODO Resolve with non emotion css without using !important
const PersistentActions = styled.ul`
  padding: 0 !important;
  display: flex;
  flex-direction: ${({isMobileOnly}) => isMobileOnly ? 'row' : 'column'};
  align-items: center;
  margin: 0 !important;
  margin-bottom: ${({isMobileOnly, isTopOfPage}) => isMobileOnly && isTopOfPage ? '32px' : '0'} !important;
  margin-top: ${({isMobileOnly, isTopOfPage}) => isMobileOnly && !isTopOfPage ? '24px' : '0'} !important;
  
  ${breakpoint.oneOff.togglePeristentActions} {
    display: ${({isMobileOnly}) => isMobileOnly ? 'none' : null};
  }
  
  ${breakpoint.atMediumWidth} {
    grid-column: 1 / 13;
  }
`

const ShareElement = styled.li`
    margin-bottom: ${({isMobileOnly}) => isMobileOnly ? '0' : '24px'} !important;
    margin-right: ${({isMobileOnly}) => isMobileOnly ? '24px' : '0'} !important;
    list-style-type: none;
    
    &::before {
      content: none !important;
    }
`

const ShareLink = styled.a`
    display: block;
    background-color: ${color.gray100};
    mask-repeat: no-repeat;
    mask-size: contain;
    mask-position: center;
    text-decoration: none;
    text-shadow: none !important;
    background-image: none !important;

    &:hover {
      cursor: pointer;
    }
`

const PocketShare = styled(ShareLink)`
   mask-image: url(${pocketSvg});
   height: ${({isMobileOnly}) => isMobileOnly ? '16px' : '24px'} !important;
   width: ${({isMobileOnly}) => isMobileOnly ? '18px' : '24px'} !important;
   
   &:hover {
    background-color: ${color.coral80};
   }
   &:active {
    background-color: ${color.coral100};
   }
`

const FacebookShare = styled(ShareLink)`
   mask-image: url(${facebookSvg});
   height: ${({isMobileOnly}) => isMobileOnly ? '18px' : '24px'} !important;
   width: ${({isMobileOnly}) => isMobileOnly ? '9px' : '24px'} !important;
   
   &:hover {
    background-color: ${color.facebook50};
   }
   &:active {
    background-color: ${color.facebook100};
   }
`

const TwitterShare = styled(ShareLink)`
   mask-image: url(${twitterSvg});
   height: ${({isMobileOnly}) => isMobileOnly ? '15px' : '24px'} !important;
   width: ${({isMobileOnly}) => isMobileOnly ? '20px' : '24px'} !important;
   
   &:hover {
    background-color: ${color.twitter50};
   }
   &:active {
    background-color: ${color.twitter100};
   }
`

const EmailShare = styled(ShareLink)`
   mask-image: url(${emailSvg});
   height: ${({isMobileOnly}) => isMobileOnly ? '15px' : '24px'} !important;
   width: ${({isMobileOnly}) => isMobileOnly ? '18px' : '24px'} !important;
   
   &:hover {
    background-color: ${color.teal80};
   }
   &:active {
    background-color: ${color.teal100};
   }
`

if (window.__STATE__) {
  if (!get(window, '__STATE__.socialWindows', false)) {
    window.__STATE__.socialWindows = {};
  }
}

// TODO decode and assemble share urls for twitter and e-mail in component instead of pulling from window state
export default ({article, isMobileOnly = false, isTopOfPage = false, twitterShareUrl, emailShareUrl}) => {
  return (
      <BodyGridColumns>
        <PersistentActions isMobileOnly={isMobileOnly} isTopOfPage={isTopOfPage}>
          <ShareElement isMobileOnly={isMobileOnly}>
            <PocketShare
                isMobileOnly={isMobileOnly}
                href={`/edit?url=${article.url}`}
                target="_blank"/>
          </ShareElement>
          <ShareElement isMobileOnly={isMobileOnly}>
            <FacebookShare
                isMobileOnly={isMobileOnly}
                onClick={() => {
                  analyticsTriggers.synArticleClickShareFacebook();
                  openRequestedPopup(`https://www.facebook.com/sharer/sharer.php?u=${wrapWithUtm(article.url, constants.socialUtmCodes.FB)}`, 'FacebookWindow', window.__STATE__.socialWindows);
                }}
                target="FacebookWindow"/>
          </ShareElement>
          <ShareElement isMobileOnly={isMobileOnly}>
            <TwitterShare
                isMobileOnly={isMobileOnly}
                onClick={() => {
                  analyticsTriggers.synArticleClickShareTwitter();
                  openRequestedPopup(twitterShareUrl, 'TwitterWindow', window.__STATE__.socialWindows);
                }}
                className="share-twitter"
                target="TwitterWindow"/>
          </ShareElement>
          <ShareElement isMobileOnly={isMobileOnly}>
            <EmailShare
                onClick={() => analyticsTriggers.synArticleClickShareEmail()}
                isMobileOnly={isMobileOnly}
                href={emailShareUrl}
                target="_blank"/>
          </ShareElement>
        </PersistentActions>
      </BodyGridColumns>
  );
}
